export default "__VITE_ASSET__DAWZWbnE__"